import ImageMain from "./imageExample/imageMainExample.png";
import ImageSamll1 from "./imageExample/imageSmallExample.png";
import ImageSamll2 from "./imageExample/imageSmallExample2.png";
import ImageSamll3 from "./imageExample/imageSmallExample3.png";
import FlagImage from "./imageExample/flag.png";
import Thumnail2 from "./imageExample/thumbnail2.jpeg";
import Thumnail3 from "./imageExample/thumbnail3.jpeg";
import LogoThumnail2 from "./imageExample/logoBread.png";
import LogoThumnail3 from "./imageExample/logothumnail3.jpg";
import PerformanceImage from "./performance/performanceImage.png";
import YoungDinnerImage from "./imageExample/youngDinnerImage.png";
import FamilyGatherersImage from "./imageExample/familyGatherersImage.png";
import WorkingProfessionalsImage from "./imageExample/workingProfessionalsImage.png";
import CasualCouplesImage from "./imageExample/casualCouplesImage.png";
import FoodEnthusiatsImage from "./imageExample/foodEnthusiatsImage.png";
import GenderImageExample from "./imageExample/genderImageExample.jpg";
import QRCodeImage from "./imageExample/qrCodeImage.png";
//Home
import ReviewChallengeImage from "./home/reviewChallengeImage.png";
import OngoingImage from "./home/onGoingImage.png";
import People5StreamlineMilano from "./home/people5StreamlineMilano.svg";
import Demo1Shopper31 from "./home/demo1Shopper31.png";
import Calendar1 from "./home/calendar1.png";

// Import IMAGES
import DefaultUploadImage from "./uploadIcon/defaultUpload.png";
import DeleteIcon from "./uploadIcon/deleteIcon.png";
import IconPNGImage from "./uploadIcon/iconPngImage.png";
import IconPDF from "./uploadIcon/iconPdf.png";
import ImageNameShop from "./imageExample/imageNameShop.png";

//Icon
import MapIcon from "./icon/mapIcon.png";
import FavoritesIcon from "./icon/favoriteIcon.png";
import ClockCircleIcon from "./icon/clockCircleIcon.png";
import CalendarIcon from "./icon/calendarIcon.png";
import StartQuestIcon from "./icon/starQuestIcon.png";
import LogoIcon from "./home/logoIcon.png";
import PointGetIcon from "./icon/pointGetIcon.png";
import HomeIcon from "./icon/homeIcon.png";
import HomeActiveIcon from "./icon/homeActiveIcon.png";
import QuestIcon from "./icon/questIcon.png";
import QuestActiveIcon from "./icon/questActiveIcon.png";
import TutorialIcon from "./icon/tutorialIcon.png";
import TutorialActiveIcon from "./icon/tutorialActiveIcon.png";
import ProfileIcon from "./icon/profileIcon.png";
import ProfileActiveIcon from "./icon/profileActiveIcon.png";
import PrevIcon from "./icon/prevIcon.png";
import NextIcon from "./icon/nextIcon.png";
import NextDisableIcon from "./icon/nextDisableIcon.png";
import ContinueIcon from "./icon/continueIcon.png";
import NextWhiteIcon from "./icon/nextWhiteIcon.png";
import TickIcon from "./icon/tickIcon.png";
import DoubleArrowIcon from "./icon/doubleUpIcon.png";
import EditIcon from "./icon/editIcon.png";
import PointIconBlue from "./icon/pointIconBlue.png";
import PerformanceIcon from "./icon/performanIcon.png";
import PerformanceIconActive from "./icon/performanIconActive.png";
import AgentIcon from "./icon/agentIcon.png";
import ArrowDownicon from "./icon/arrowDownIcon.png";
import ArrowUpicon from "./icon/arrowUpIcon.png";
import SelectIcon from "./icon/selectIcon.png";
import ManualIputIcon from "./icon/manualInputIcon.png";
import TrashIcon from "./icon/trashIcon.png";
import TrashLocationIcon from "./icon/trashLocationIcon.png";
import DeleteModalIcon from "./icon/deleteModalIcon.png";
import AddCircleIconBlue from "./icon/addCircleIcon.png";
import SearchIcon from "./icon/searchIcon.png";
import MapOndemandIcon from "./icon/mapOndemandIcon.png";
import SumIcon from "./icon/sumIcon.png";
import MinusIcon from "./icon/minusIcon.png";
import ShareIcon from "./icon/shareIcon.png";
import BackIconGray from "./icon/backIconGray.png";
import PlusIconBlue from "./icon/plusIconBlue.png";
import MinusCircleIcon from "./icon/minusCircleIcon.png";
import PlusIconBlack from "./icon/plusIconBlack.png";
import CalendarIconBlack from "./icon/calendarIconBlack.png";
import ChevronRightIconBlack from "./icon/chevronRightIcon.png";
import CheckIconBlack from "./icon/checkIconBlack.png";
import PencilIconBlue from "./icon/pencilIconBlue.png";
import PencilIconBlack from "./icon/pencilIconBlack.png";
import BackIconBlack from "./icon/backIconBlack.png";
import CheckIconWhite from "./icon/checkIconWhite.png";
import GenAIIconWhite from "./icon/genAIIconWhite.png";
import ThreeDotIcon from "./icon/threeDotIcon.png";
import MessageIcon from "./icon/messageIcon.png";
import SendChatIcon from "./icon/sendChatIcon.png";
import MicroPhoneIcon from "./icon/microphoneIcon.png";
import UserChatBotIcon from "./icon/chatboxUserIcon.png";
import ChatBoxHeaderIcon from "./icon/chatboxHeaderIcon.png";
import TrashIconRed from "./icon/trashIconRed.png";
import InfoCircleIcon from "./icon/infoCircleIcon.png";
import QRCodeIcon from "./icon/qr_code.png";
import ListGroupIcon from "./icon/list_icon.png";
import DownloadIcon from "./icon/downloadIcon.png";
import DotMapIconWhite from "./icon/dotMapIcon.png";
import PencilIconWhite from "./icon/pencilIconWhite.png";
import FilterIcon from "./icon/filterIcon.png";
import ArrowLeftIcon from "./icon/arrowLeft.png";
import DotMapIconBlue from "./icon/dotmapBlueIcon.png";
import DiscardIcon from "./icon/discardIcon.png";
import SaveDraftIcon from "./icon/saveDraftIcon.png";
import MenuIconWhite from "./icon/menuIconWhite.png";
import CloseIconWhite from "./icon/closeIconWhite.png";

//Icon Login

import WhatsappIcon from "./login/whatsappIcon.png";
import UserIcon from "./login/userIcon.png";
import PhoneIcon from "./login/phoneIcon.png";
import LogoLogin from "./login/logoLogin.png";
import GenderIcon from "./login/genderIcon.png";
import BackIcon from "./icon/backIcon.png";
import MenuIcon from "./icon/menuIcon.png";
import MenuIconGray from "./icon/menuIconGray.png";
import OclockIcon from "./icon/oclockIcon.png";
import LetterIcon from "./login/letter.png";
import KeyIcon from "./login/keyIcon.png";
import EyesIcon from "./login/eyesIcon.png";

//Quest Image
import TaskQuestModalImage from "./quest/taskQuestModalImage.png";
import PauseQuestImageModal from "./quest/pauseQuestImage.png";
import SubmitQuestImageModal from "./quest/submitQuestImage.png";
import ReviewCompleteQuestImageModal from "./quest/questReviewCompleteImg.png";
import CompleteQuestImage from "./quest/questCompleteImage.png";
import QuestTaskIcon from "./quest/questTaskIcon.png";
import ChartIcon from "./quest/chartIcon.png";
import EyesQuestIcon from "./quest/eyesQuest.png";
import ChevronNextIcon from "./quest/chevronNextIcon.png";
import ChevronDownIcon from "./icon/chevronDownIcon.png";
import GenAIIconGray from "./icon/AIgentIconGray.png";

import QuestResultImage from "./quest/questResultImages.png";
import SlideIcon from "./quest/slideIcon.png";
import GroupIconQuestResult from "./quest/groupIconQuestResult.png";
import QuestionIconQuestResult from "./quest/questionIconQuestResult.png";
import ZapIcon from "./quest/zapIcon.png";
import ExpiryTimeIconYellow from "./quest/timeIconYellow.png";
import MapIconYellow from "./quest/mapIconYellow.png";
import EditQuestIcon from "./quest/EditQuestIcon.png";
import PluscircleIcon from "./quest/PluscircleIcon.png";
import toggleOnIcon from "./quest/toggleOnIcon.png";
import BinIcon from "./quest/BinIcon.png";
//Profile

import LogoProfile from "./profile/logoProfile.png";
import UpdateModalImage from "./profile/updateModalImage.png";
import PayNowImage from "./profile/payNowImage.png";
import CheckCircleIcon from "./profile/checkCircleIcon.png";
import WithdrawSuccessImage from "./profile/withDrawSuccessImage.png";
import BuildingIcon from "./profile/buildingsIcon.png";
import BookmarkIcon from "./profile/bookmarkCircleIcon.png";
import TagIcon from "./profile/tagIcon.png";
import GlobalIcon from "./profile/globalIcon.png";
import MapPointIcon from "./profile/mapPointIcon.png";
import AddCircleIcon from "./profile/addCircleIcon.png";
import MoneyIcon from "./profile/moneyIcon.png";
import WalletIcon from "./profile/walletIcon.png";
//OP preview
import PreviewImage from "./login/previewImage.png";
import OPPreviewImageStep2 from "./login/OPPreviewImage2.png";
import OPPreviewImageStep3 from "./login/OPPreviewImage3.png";

//performance

import LockIcon from "./performance/lockIconPerformance.png";

// Export your image
const images = {
  //images
  DefaultUploadImage,
  DeleteIcon,
  IconPNGImage,
  IconPDF,
  MapIcon,
  FavoritesIcon,
  ClockCircleIcon,
  CalendarIcon,
  StartQuestIcon,
  LogoIcon,
  PointGetIcon,

  //Preview
  PreviewImage,
  OPPreviewImageStep2,
  OPPreviewImageStep3,

  //Home image
  ReviewChallengeImage,
  OngoingImage,
  People5StreamlineMilano,
  Demo1Shopper31,
  Calendar1,

  //Icon Login

  WhatsappIcon,
  UserIcon,
  PhoneIcon,
  LogoLogin,
  GenderIcon,
  HomeIcon,
  HomeActiveIcon,
  QuestIcon,
  QuestActiveIcon,
  TutorialIcon,
  TutorialActiveIcon,
  ProfileIcon,
  ProfileActiveIcon,
  PrevIcon,
  NextIcon,
  ContinueIcon,
  NextDisableIcon,
  NextWhiteIcon,
  BackIcon,
  MenuIcon,
  TickIcon,
  OclockIcon,
  DoubleArrowIcon,
  KeyIcon,
  LetterIcon,
  EyesIcon,
  PerformanceIcon,
  PerformanceIconActive,
  SearchIcon,
  BackIconGray,
  AgentIcon,
  ArrowDownicon,
  ArrowUpicon,
  SelectIcon,
  ManualIputIcon,
  TrashIcon,
  DeleteModalIcon,
  AddCircleIconBlue,
  ChevronDownIcon,
  MenuIconGray,
  MapOndemandIcon,
  SumIcon,
  MinusIcon,
  ShareIcon,
  MessageIcon,
  SendChatIcon,
  MicroPhoneIcon,
  UserChatBotIcon,
  ChatBoxHeaderIcon,
  PencilIconBlue,
  PencilIconBlack,
  BackIconBlack,
  CheckIconWhite,
  GenAIIconWhite,
  GenAIIconGray,
  ThreeDotIcon,
  TrashIconRed,
  PlusIconBlue,
  MinusCircleIcon,
  InfoCircleIcon,
  PlusIconBlack,
  CalendarIconBlack,
  ChevronRightIconBlack,
  CheckIconBlack,
  QRCodeIcon,
  ListGroupIcon,
  DownloadIcon,
  DotMapIconWhite,
  PencilIconWhite,
  TrashLocationIcon,
  FilterIcon,
  ArrowLeftIcon,
  DotMapIconBlue,
  DiscardIcon,
  SaveDraftIcon,
  MenuIconWhite,
  CloseIconWhite,
  //Quest Image
  TaskQuestModalImage,
  PauseQuestImageModal,
  SubmitQuestImageModal,
  ReviewCompleteQuestImageModal,
  CompleteQuestImage,
  PointIconBlue,
  QuestTaskIcon,
  ChartIcon,
  EyesQuestIcon,
  ChevronNextIcon,
  QuestResultImage,
  SlideIcon,
  QuestionIconQuestResult,
  GroupIconQuestResult,
  ZapIcon,
  ExpiryTimeIconYellow,
  MapIconYellow,
  EditQuestIcon,
  PluscircleIcon,
  toggleOnIcon,
  BinIcon,
  //Profile
  LogoProfile,
  EditIcon,
  UpdateModalImage,
  PayNowImage,
  FlagImage,
  CheckCircleIcon,
  WithdrawSuccessImage,
  BuildingIcon,
  BookmarkIcon,
  TagIcon,
  GlobalIcon,
  MapPointIcon,
  AddCircleIcon,
  MoneyIcon,
  WalletIcon,

  //performance
  LockIcon,
  //Image Example
  ImageMain,
  ImageSamll1,
  ImageSamll2,
  ImageSamll3,
  ImageNameShop,
  Thumnail2,
  Thumnail3,
  LogoThumnail2,
  LogoThumnail3,
  PerformanceImage,
  YoungDinnerImage,
  FamilyGatherersImage,
  WorkingProfessionalsImage,
  CasualCouplesImage,
  FoodEnthusiatsImage,
  GenderImageExample,
  QRCodeImage,
};

export default images;
